<div class="row">
    <div class="card-body prpl">
        <form autocomplete="off" class="p-0" novalidate [formGroup]="centerAllocationForm">
            <div class="row">
                <div class="bc d-flex align-items-center pl-3">
                    <img alt="Logo" src="../../assets/img/CollegeMaster.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Block List
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Block List
                        </p>
                    </div>
                </div>
                <div class="table-responsive table-container">
                    <div class="col-sm-12" *ngIf="showTable">

                        <div class="table-responsive table-container">
                            <table class="table text-nowrap table-bordered text-left">
                                <thead>
                                    <tr>
                                        <th class="f600">
                                            Action
                                        </th>
                                        <th class="f600">
                                            Block Name
                                        </th>
                                        <th class="f600">
                                            Allocation
                                        </th>
                                        <th class="f600">
                                            Block Capacity
                                        </th>



                                    </tr>
                                </thead>
                                <tbody id="table_data" formArrayName="ExamArray">
                                    <tr style="cursor:pointer;"
                                        *ngFor="let exm of getExamArrayControls(); let i = index" [formGroupName]="i">
                                        <td class="text-center">
                                            <mat-checkbox formControlName="selected">
                                            </mat-checkbox>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control" formControlName="blockName"
                                                readonly>
                                        </td>
                                        <td>
                                            <input type="text" class="form-control" formControlName="Allocation" (change)="validation(i)">
                                        </td>
                                        <td>
                                            <input type="text" class="form-control" formControlName="blockCapacity"
                                                readonly>
                                        </td>


                                        <!-- <td>
                                                                        <input type="text" class="form-control"
                                                                            formControlName="EsCode" readonly>
                                                                    </td> -->


                                        <!-- <td>{{course.DsName}} </td> -->
                                        <!-- <td class="text-center">
                                                                        <a class="floating mr-2 pr-3" title="Edit"
                                                                        > <i class="fa fa-edit "></i> </a>
                                                                       
                                                                    </td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="row prpl">
                    <div class="col-sm-12 ">

                        <button type="button" class="btn fr sz btn-primary btn-icon-text floatright mt-1"
                             (click)="save()" [disabled]="saveBtn">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                Save
                            </span>
                        </button>

                        <button id="Back" type="button" [mat-dialog-close]="true"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                {{'header.college-data.titleList.Back' |translate }}
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>